import InAppBrowser from 'react-native-inappbrowser-reborn';
import { Logger } from './Logger';
import { openLink } from './linkUtils';

export const openInAppWebViewer = async (url: string) => {
    const webViewOptions = {
        // iOS Properties
        dismissButtonStyle: 'close',
        readerMode: false,
        animated: true,
        modalPresentationStyle: 'fullScreen',
        modalTransitionStyle: 'coverVertical',
        modalEnabled: true,
        enableBarCollapsing: false,
        // Android Properties
        showTitle: true,
        enableUrlBarHiding: true,
        enableDefaultShare: true,
        forceCloseOnRedirection: false,
        animations: {
            startEnter: 'slide_in_right',
            startExit: 'slide_out_left',
            endEnter: 'slide_in_left',
            endExit: 'slide_out_right',
        },
    };
    try {
        if (await InAppBrowser.isAvailable()) {
            InAppBrowser.closeAuth();
            await InAppBrowser.open(url, webViewOptions);
        } else {
            await openLink(url);
        }
    } catch (error) {
        Logger.notify(error);
    }
};

export const openInAppWebViewerInBackground = (url: string) => {
  openInAppWebViewer(url).catch((e) => { /* errors handled in openInAppWebViewer */ });
};
